import {
  createSlice,
  createEntityAdapter,
  PayloadAction,
  createSelector,
} from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { ProjectOwner } from 'types/store/projectsList';

const ownersAdapter = createEntityAdapter<ProjectOwner>();
const initialState = ownersAdapter.getInitialState();

const ownersSlice = createSlice({
  name: 'projectsList/include/owners',
  initialState,
  reducers: {
    updateOwners: (
      state,
      action: PayloadAction<{
        owners: ProjectOwner[];
        shouldReplace: boolean;
      }>
    ) => {
      const { owners, shouldReplace } = action.payload;
      if (shouldReplace) {
        ownersAdapter.setAll(state, owners);
      } else {
        ownersAdapter.upsertMany(state, owners);
      }
    },
    removeAllOwners: (state) => {
      ownersAdapter.removeAll(state);
    },
  },
});

export const { updateOwners, removeAllOwners } = ownersSlice.actions;

const selectOwners = (state: RootState) => state.projectsList.include.owners;

export const { selectAll: selectAllOwners } =
  ownersAdapter.getSelectors<RootState>(selectOwners);

export const selectProjectOwnersById = createSelector(
  [selectAllOwners, (_, ownersIds: string[]) => ownersIds],
  (owners, ownersIds) => {
    return owners.filter((owner) => ownersIds.includes(owner.id));
  }
);

export default ownersSlice.reducer;
